import { put, takeLatest } from 'redux-saga/effects'
import { getSuppliers } from 'redux/actions'
import { get } from 'shared/api/api'
import { getType } from 'typesafe-actions'

function* getSuppliersSaga(action: ReturnType<typeof getSuppliers.request>) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const list: any = yield get({
            host: 'https://orchestrator-cdcalendar.platformeco.lmru.tech',
            url: `/partners/v1/suppliers?id=${action.payload}`
        })

        yield put(getSuppliers.success(list))
    } catch (e) {
        console.log(e)
    }
}

export const suppliersSaga = [takeLatest(getType(getSuppliers.request), getSuppliersSaga)]
